import { render, staticRenderFns } from "./ExternalIcon.vue?vue&type=template&id=4bd66f5b&"
import script from "./ExternalIcon.vue?vue&type=script&lang=js&"
export * from "./ExternalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports